import { render, staticRenderFns } from "./SeminarVideos.vue?vue&type=template&id=71405fb8"
import script from "./SeminarVideos.vue?vue&type=script&lang=js"
export * from "./SeminarVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports